import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { isNumber } from 'modules/core/lib/validateNumberInput'

class Identification extends Form {
  constructor(values: object) {
    super(values, {
      tin: 'string',
      legal_name: 'string',
      siret: 'string',
      isFranceLegalEntity: 'boolean',
    })
    makeObservable(this, {
      isFranceLegalEntity: computed,
      isValidSiret: computed,
      isValid: computed,
    })
  }

  get isFranceLegalEntity(): boolean {
    return this.get('isFranceLegalEntity').value
  }

  get isValidSiret(): boolean {
    const siret = this.get('siret').value

    return isNumber(siret) && siret.length === 14
  }

  get isValid(): boolean {
    if (!this.isFranceLegalEntity) return true

    return this.isValidSiret
  }
}

export default Identification
